// extracted by mini-css-extract-plugin
module.exports = {"closeModal":"styles_closeModal__2XUSP","notificationModalTitle":"styles_notificationModalTitle__1sF5c","description":"styles_description__wTZCP"};